{
  "imported_from": "Added from {{feed}}",
  "hide_entry_toast": {
    "title": "Item hidden",
    "undo": "undo"
  },
  "week_column": {
    "add_item": "Add an item"
  },
  "empty_state": {
    "add_item": "Add an item",
    "mobile_title": "No items this month!",
    "week_title": "No items this week!"
  },
  "entry_time": {
    "starts_at": "Starts at {{time}}",
    "ends_at": "Ends at {{time}}"
  },
  "errors": {
    "creating_entry": "Error creating item",
    "updating_entry": "Error updating item",
    "deleting_entry": "Error deleting item",
    "hiding_entry": "Error hiding item",
    "unhiding_entry": "Error unhiding item",
    "invalid_permissions": {
      "title": "This schedule is private",
      "anonymous_message": "If you think you should have access, please <2>sign up</2> or <6>login first</6>.",
      "user_message": "You're signed in as <1>{{email}}</1>.<3/> Would you like to request access from the schedule owner?",
      "request_access": "Request access",
      "request_access_success": "We've invited the schedule owner to share access with you. You'll receive an email notification if they approve."
    },
    "not_found": {
      "title": "Schedule not found"
    },
    "unknown": {
      "title": "Error loading schedule"
    },
    "unsupported_view": "Schedule does not support this view"
  },
  "copy_link": {
    "copy_button": "Copy link",
    "copy_success": "✅ Link copied!",
    "copy_failed_description": "We were unable to copy the link to the clipboard"
  },
  "agenda_view": {
    "delete_item_toast": {
      "success": "Item deleted!",
      "error": "Error deleting item"
    },
    "more_menu": {
      "aria": "More",
      "edit": "Edit",
      "delete": {
        "delete": "Delete",
        "confirm": "Confirm",
        "cancel": "Cancel"
      }
    },
    "properties": {
      "messages": "This item has messages",
      "repeats": "This item is repeating"
    },
    "messages": {
      "only_editors": "✨ Only editors can see this"
    },
    "empty_state": {
      "title": "No items to display",
      "message": "Try changing your dates or filters to see items.",
      "add_item": "Add an item"
    }
  },
  "banner": {
    "add_action": "Add banner image",
    "remove_action": "Remove image",
    "toggle_action_ai": "Use AI image",
    "toggle_action_default": "Use default image",
    "error_removing": "Unable to remove image",
    "error_adding": "Unable to add image",
    "error_toggling_ai": "Error setting AI image",
    "error_toggling_default": "Error setting default image"
  },
  "copy_schedule": {
    "action": "Copy schedule",
    "success_toast_title": "✨ Schedule copied!",
    "success_toast_description": "A copy of this schedule has been created in your account",
    "error_toast": "Error copying schedule"
  },
  "follow_schedule": {
    "follow_schedule": "Follow schedule",
    "follow_success": "Schedule followed",
    "follow_success_popover": "This schedule will now appear in your dashboard of schedules. <2>Show me →</2>",
    "follow_error_toast": "Error following schedule",
    "unfollow_schedule": "Following",
    "unfollow_success_toast": "Schedule unfollowed",
    "unfollow_error_toast": "Error unfollowing schedule",
    "unfollow_confirm": {
      "title": "Unfollow schedule?",
      "message": "This schedule will no longer appear in your dashboard of schedules.",
      "confirm": "Yes, unfollow"
    }
  }
}
